import type { MePayload, TeamRole } from "@/lib/types";

export type PublicNavCapabilities = {
  signedIn: boolean;
  displayName: string | null;
  canOpenCoach: boolean;
  canOpenFeedback: boolean;
  canOpenAdmin: boolean;
};

const COACH_ROLES = new Set<TeamRole>(["coach", "assistant_coach", "team_admin"]);

export function getPublicNavCapabilities(
  me: MePayload | null | undefined,
): PublicNavCapabilities {
  const user = me?.user;
  const memberships = me?.memberships ?? [];
  const roles = user?.roles ?? [];
  const isGlobalAdmin = !!user?.is_global_admin || roles.includes("admin");
  const isUploader = roles.includes("uploader");
  const isTeamAdmin = memberships.some((m) => m.role === "team_admin");
  const hasCoachRole = memberships.some((m) => COACH_ROLES.has(m.role));

  return {
    signedIn: !!user,
    displayName:
      user?.display_name?.trim() ||
      me?.profile?.display_name?.trim() ||
      user?.username?.trim() ||
      null,
    canOpenCoach: isGlobalAdmin || hasCoachRole,
    canOpenFeedback: !!user,
    canOpenAdmin: isGlobalAdmin || isUploader || isTeamAdmin,
  };
}
